import { AxiosError, AxiosStatic } from "axios";
import axiosRetry from "axios-retry";

type SetupAxiosRetry = (axios: AxiosStatic, retries?: number) => void;

/**
 * Sets up axios-retry for the axios instance
 * @param @optional {number} retries The number of retries, default is 3
 */
export const setupAxiosRetry: SetupAxiosRetry = (axios, retries?) =>
  axiosRetry(axios, {
    retries: retries || 3,
    retryDelay: axiosRetry.exponentialDelay,
    retryCondition: (error: AxiosError) =>
      error.code == "429" || !error.response,
  });
